<template>
  <!-- v-html로 들어갈 message나 component를 받아서 모달을 띄워주는 컴포넌트 -->
  <transition v-if="isDataModalOpen" name="layer">
    <div class="exchange_layer">
      <div class="layer_deco">
        <div class="layer" :class="[message ? 'info' : 'auto']">
          <!-- header가 있으면 정해진 header 디자인을 노출 -->
          <div v-if="header" class="popup_header">
            <h1 v-html="header"></h1>
          </div>
          <button @click="handleClick()" :class="[header ? 'btn_close2' : 'btn_close_black']" />
          <!-- message가 있으면 Viewer로 노출 -->
          <div v-if="message" class="content">
            <Viewer :initialValue="message" />
          </div>
          <!-- component가 있으면 해당 컴포넌트를 노출 -->
          <component v-if="component" :is="component" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import VButton from '@/components/atoms/VButton';
import { mapActions, mapGetters } from 'vuex';
import { Viewer } from '@toast-ui/vue-editor';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';

export default {
  components: {
    VButton,
    Viewer,
  },
  computed: {
    ...mapGetters('modal', ['isDataModalOpen', 'header', 'message', 'component']),
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    handleClick() {
      this.closeModal();
    },
  },
};
</script>
<style lang="scss">
.exchange_layer {
  .layer {
    &.info {
      // max-height: 800px;
      max-height: 80%;
    }
    &.auto {
      height: auto;
      min-height: auto;
    }
    .content {
      height: 100%;
      position: absolute;
      width: 100%;
      padding: 90px 20px 0 20px;
      // margin: 0 0 0 20px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #eee;
      }
      &::-webkit-scrollbar-track {
        border-radius: 10px;
      }
    }
  }
}

@media all and (max-width: 767px) {
  .exchange_layer {
    .layer {
      &.auto {
        height: 100%;
        min-height: 100%;
      }
      min-height: 100%;
    }
  }
}
</style>
